import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { UserModel } from '../../../user/models/user.model';

@Injectable({
  providedIn: 'root',
})
export class PrivacyService {
  constructor(private http: HttpClient) {}

  acceptTerms() {
    return this.http.post<UserModel>(`${environment.BASE_PATH}/privacy/accept-terms`, {});
  }
}
